import { LoadingContainer, Model } from 'peach/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { useClickAction } from 'peach/decorators/withActionTrigger'

import { Page } from 'core/components'
import { useGetWorkflowTypes } from 'core/types'

const WorkflowTypes = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const { data: workflowTypes, isLoading } = useGetWorkflowTypes({ companyId })

  useClickAction({
    label: 'Create Workflow Type',
    onClick: () => history.push(`${url}/create-workflow-type`),
  })

  return (
    <LoadingContainer isLoading={isLoading}>
      <Page variant='full'>
        <Model.List
          json={workflowTypes}
          title='Workflow Types'
          withDetails
          withRelated
          withTimestamps
        />
      </Page>
    </LoadingContainer>
  )
}

export default WorkflowTypes
